// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { UploadQueueProvider } from "./contexts/UploadQueueContext";
import { completeMicrosoftRedirect } from "./config/microsoftLogin";
import "./index.css";
import "./theme.css";
import App from "./App";
import OfflineBanner from "./components/ui/OfflineBanner";
import DevBalk from "./components/ui/DevBalk";
import reportWebVitals from "./reportWebVitals";

// Create a QueryClient instance with secure defaults for medical data
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // Keep data fresh while avoiding instant refetch on navigation
      gcTime: 5 * 60_000, // Retain cache briefly for faster route transitions
      retry: 1, // Only retry once for failed requests
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Een eventuele terugkeer van de Microsoft-login-redirect afronden vóór de
// eerste render: pas daarna mag de router de URL aanpassen. Rendert altijd,
// ook als de afronding faalt (de foutmelding staat dan klaar voor LoginPage).
completeMicrosoftRedirect().finally(() => {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <UploadQueueProvider>
              {/* Vóór App: bovenaan élk scherm, ook de inlogpagina; rendert
                  alleen op de DEV-omgeving. */}
              <DevBalk />
              <App />
              <OfflineBanner />
            </UploadQueueProvider>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );

  reportWebVitals();
});
